import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import logger from "redux-logger";
import producerReducer from "./ProducerSlice";
import userReducer from "./UserSlice";
import appReducer from "./appSlice";
import adminReducer from "../feature/admin/slice";

const rootReducer = combineReducers({
  app: appReducer,
  producer: producerReducer,
  user: userReducer,
  admin: adminReducer,
});

const isDev = process.env.NODE_ENV !== "production";

/**
   configure store with appSlice
*/
const store = configureStore({
  reducer: rootReducer,
  devTools: isDev,
  middleware: (getDefaultMiddleware) => {
    const middleware = getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false,
    });

    if (isDev) {
      return middleware.concat(logger);
    }

    return middleware;
  },
});

export default store;

export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;
